var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "poll-games" },
    [
      _c("img", {
        staticClass: "answer-img",
        attrs: { src: this.pollGames.answerImageUrl },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "footer-slogan",
        attrs: { src: "/public/footer_slogan.png" },
      }),
      _vm._v(" "),
      _c("Appstore", { attrs: { pageName: "pollGame" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/PollGames.vue